var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.messagesLoading),expression:"messagesLoading"}],staticClass:"message-container"},[_c('Message',{attrs:{"list":_vm.messages.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }